import styled from 'styled-components';
import { sizes } from 'style';
import { ReactComponent as CurveImg } from 'products/global/assets/img/join-us/benefits-curve.svg';
import { colors } from 'style/theme';

export const BenefitsBackground = styled.div`
  background-color: ${({ theme }) => theme.colors.turquoise};
  min-height: 760px;
  width: 100%;
  display: flex;
`;

export const BenefitsContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 1340px;
  height: 100%;
  padding: 0px 20px;
  margin: 0 auto;
  padding-top: 44px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media ${sizes.tabletLandscape} {
    padding: 0px 40px;
    padding-top: 100px;
  }
`;

export const Curve = styled(CurveImg)`
  position: absolute;
  width: 100%;
  color: ${({ theme }) => theme.colors.turquoise};
`;

export const Heading = styled.h1`
  font-size: 24px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.black};
  margin-bottom: 25px;
  line-height: 40px;
  z-index: 2;

  @media ${sizes.tabletLandscape} {
    margin-bottom: 38px;
    font-size: 32px;
    line-height: 44px;
    margin-top: 0px;
  }
`;

export const SeeOpenRoles = styled.button`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  border: 0;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${colors.deepBlush};
  font-size: 16px;
  line-height: 26px;
  border-radius: 12px;
  padding: 8px 32px;
  transition: background-color 0.3s;
  margin-top: 90px;
  margin-bottom: 48px;

  :hover {
    background-color: #ca2b50;
  }

  > span {
    font-weight: 600;
  }

  @media ${sizes.tabletLandscape} {
    margin-bottom: 0px;
    margin-top: 47px;
    margin-bottom: 10px;
    padding: 10px 36px;
    line-height: 24px;
  }
`;
